import { apiRequest } from "./client";

function buildProductFormData(payload = {}, files = []) {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (Array.isArray(value) || (typeof value === "object" && value !== null)) {
      formData.append(key, JSON.stringify(value));
      return;
    }
    formData.append(key, typeof value === "boolean" ? String(value) : value);
  });

  (files || []).forEach((file) => {
    formData.append("images", file);
  });

  return formData;
}

export const productsApi = {
  list(projectId, params = {}) {
    const query = new URLSearchParams(params).toString();
    return apiRequest(`/projects/${projectId}/products${query ? `?${query}` : ""}`);
  },

  lookupCode(projectId, code) {
    const query = new URLSearchParams({ code: String(code || "").trim() }).toString();
    return apiRequest(`/projects/${projectId}/products/lookup-code?${query}`);
  },

  // files: array de File (input type="file" multiple), opcional.
  // Si hay archivos, se manda como multipart/form-data (así lo espera Multer en el back).
  create(projectId, payload, files = [], options = {}) {
    if (files?.length) {
      return apiRequest(`/projects/${projectId}/products`, {
        method: "POST",
        body: buildProductFormData(payload, files),
        onUploadProgress: options.onUploadProgress,
      });
    }
    return apiRequest(`/projects/${projectId}/products`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  update(projectId, productId, payload, files = [], options = {}) {
    if (files?.length) {
      return apiRequest(`/projects/${projectId}/products/${productId}`, {
        method: "PUT",
        body: buildProductFormData(payload, files),
        onUploadProgress: options.onUploadProgress,
      });
    }
    return apiRequest(`/projects/${projectId}/products/${productId}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  remove(projectId, productId) {
    return apiRequest(`/projects/${projectId}/products/${productId}`, {
      method: "DELETE",
    });
  },
};
